import Vue from 'vue';
import CheckNetwork from './CheckNetwork.vue';
// eslint-disable-next-line import/no-cycle

let toastVue;

function createToast() {
  const vnode = new Vue({
    render: h => h(CheckNetwork),
  }).$mount();
  document.body.appendChild(vnode.$el);
  return vnode.$children[0];
}

export function showCheckNet(args) {
  if (!toastVue) {
    toastVue = createToast();
  }
  toastVue.show(args);
  return toastVue;
}

export function hideCheckNet(args) {
  if (!toastVue) return;
  toastVue.hide(args);
  // eslint-disable-next-line consistent-return
  return toastVue;
}

// export default showSaveToast;
